/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_item">;
    readonly " $refType": "PdpRespSidebarSellerInfoAndContactLazy_item";
};
export type PdpRespSidebarSellerInfoAndContactLazy_item$data = PdpRespSidebarSellerInfoAndContactLazy_item;
export type PdpRespSidebarSellerInfoAndContactLazy_item$key = {
    readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '2a1b1a349f1bae1b3a1d127a673f3faf';
export default node;
